<div class="discount-rejection-coupon-appearance">
  <pdq-card variant="popover" color="white">
    <div class="card-header">
      <pdq-heading element="h5">Appearance</pdq-heading>
    </div>
    <pdq-divider></pdq-divider>

    <div class="card-content" [formGroup]="appearanceFormGroup">
      <!-- Widget Type -->
      <div class="section-group">
        <span class="section-label body-14-medium">Widget type</span>
        <pdq-radio-group formControlName="widgetType">
          @for (option of widgetTypeRadioOptions; track option.value) {
            <pdq-radio-button
              [value]="option.value"
              [checked]="appearanceFormGroup.get('widgetType')?.value === option.value"
              [disabled]="option.value === WidgetType.CLICKABLE && isClickableDisabled"
              [text]="option.text"></pdq-radio-button>
          }
        </pdq-radio-group>
      </div>

      <!-- Widget Appearance -->
      <div class="section-group" formGroupName="widgetAppearance">
        <span class="section-label body-14-medium">Widget appearance</span>
        <div class="three-column-grid">
          @for (field of widgetAppearanceFields; track field.controlName) {
            <pdq-dropdown
              [title]="field.title"
              [formControlName]="field.controlName"
              [options]="field.options"></pdq-dropdown>
          }
        </div>
      </div>

      <!-- Button -->
      @if (appearanceFormGroup.get('widgetType')?.value === WidgetType.CLICKABLE) {
        <div class="section-group" formGroupName="buttonAppearance">
          <span class="section-label body-14-medium">Button</span>
          <div class="three-column-grid">
            @for (field of buttonFields; track field.controlName) {
              @if (field.type === 'input') {
                <pdq-input
                  [label]="field.label"
                  [placeholder]="field.placeholder"
                  [formControlName]="field.controlName"></pdq-input>
              } @else {
                <pdq-dropdown
                  [title]="field.title"
                  [formControlName]="field.controlName"
                  [options]="field.options"></pdq-dropdown>
              }
            }
          </div>
        </div>
      }
    </div>
  </pdq-card>
</div>
